module.exports = __webpack_public_path__ + "static/media/Songs 1.d7efa9e0.svg";